import React from 'react';
import { Star, ShieldCheck, Clock, RefreshCw } from 'lucide-react';
export function TopBar() {
  const items = [{
    icon: <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-258" />,
    text: 'Sistema 100% paso a paso'
  }, {
    icon: <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-259" />,
    text: 'Pago 100% seguro'
  }, {
    icon: <Clock className="w-4 h-4 text-brand-gold" data-id="element-260" />,
    text: 'Acceso inmediato de por vida'
  }, {
    icon: <RefreshCw className="w-4 h-4 text-brand-gold" data-id="element-261" />,
    text: 'Actualizaciones gratuitas'
  }];
  return <div className="bg-brand-green text-white py-3 text-sm" data-id="element-262">
      <div className="container mx-auto px-6" data-id="element-263">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-x-8 gap-y-2 max-w-6xl mx-auto" data-id="element-264">
          {items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-265">
              {item.icon}
              <span className="font-medium text-white/90" data-id="element-266">{item.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}